import './stepper.scss';

import React from 'react';

export interface StepperRootProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'vertical' | 'horizontal';
}

function StepperRoot({
  className = '',
  children,
  orientation = 'vertical',
  ...props
}: StepperRootProps): JSX.Element {
  return (
    <div className={`stepper stepper-${orientation} ${className}`} role="list" {...props}>
      {children}
    </div>
  );
}

export default StepperRoot;
